import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'
import {
  useAddParkMutation,
  useGetParkByIdQuery,
  useUpdateParkMutation,
} from 'src/api/manageParksApi'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'
import { useGetProductByIdQuery, useUpdateProductMutation } from 'src/api/manageProductsApi'
import { IFormInput, formSchema } from '../AddModal/useAddHook'


type useEditHookProps = {
  successCallback: () => void
  id: number
}
const useEditHook = ({ successCallback, id }: useEditHookProps) => {
  const [file, setFile] = useState<File | null>(null)
  const [imageUrl, setImageUrl] = useState<string>('')
  const [showUploadImage, setShowUploadImage] = useState(false)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    watch,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      title: '',
      productType: '',
      category: 0,
      price: 0,
      unit: '',
      description: '',
      isActive: true,
    },
  })
  const { data, isFetching, refetch } = useGetProductByIdQuery(id)

  const [updateProduct, { isLoading: isLoadingEditPark }] = useUpdateProductMutation()
  const dispatch = useDispatch<AppDispatch>()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)

    if (!data.price) {
      errorToast('Amount is required.')
      return
    }

    if (!data.category) {
      errorToast('Category is required.')
      return
    }
    const formData = new FormData()
    formData.append('title', data.title)
    formData.append('price', data.price.toString())
    formData.append('unit', data.unit)
    formData.append('description', data.description)
    formData.append('is_active', JSON.stringify(data.isActive))
    formData.append('item_type', data.productType)
    formData.append('supplement_type_id', data.category.toString())
    if (file) {
      formData.append('picture', file)
    }
    updateProduct({
      id,
      data: formData,
    })
      .unwrap()
      .then((res) => {
        console.log(res)
        successToast('Park updated successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to updated park.')
      })
  }

  const resetCategory = () => {
    setValue('category', 0)
  }

  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  useEffect(() => {
    if (data) {
      setValue('title', data.title)
      setValue('price', +data.price)
      setValue('unit', data.unit)
      setValue('description', data.description)
      setValue('category', data.supplement_type.id)
      setValue('productType', data.item_type)
      setValue('isActive',!!data.is_active)
      if (data.picture) {
        setImageUrl(data.picture)
      }
    }
  }, [data])

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingEditPark,
    imageUrl,
    showUploadImage,
    handleShowUploadImage: () => setShowUploadImage(true),
    product: data,
    watchState: {
      productType: watch('productType'),
    },
    resetCategory,
    handleChangeStatus: (event: React.ChangeEvent<HTMLInputElement>) => {
      setValue('isActive', !!event.target.checked)
    },
  }
}

export default useEditHook
